"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountService = void 0;
var AccountService = (function () {
    function AccountService() {
    }
    AccountService.prototype.create = function (login, password, companyId, permissions) {
        return new Promise(function (resolve, reject) {
            fetch('/api/account/create', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ login: login, password: password, companyId: companyId, permissions: permissions }),
            })
                .then(function (res) { return res.json(); })
                .then(function (res) {
                if (res.hasOwnProperty('error')) {
                    reject(res.error);
                }
                else {
                    resolve();
                }
            })
                .catch(function (err) { return reject(err.message); });
        });
    };
    AccountService.prototype.remove = function (accountId) {
        return new Promise(function (resolve, reject) {
            fetch('/api/account/remove', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ accountId: accountId }),
            })
                .then(function (res) { return res.json(); })
                .then(function (res) {
                if (res.hasOwnProperty('error')) {
                    reject(res.error);
                }
                else {
                    resolve();
                }
            })
                .catch(function (err) { return reject(err.message); });
        });
    };
    AccountService.prototype.changePassword = function (accountId, password) {
        return new Promise(function (resolve, reject) {
            fetch('/api/account/changePassword', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ accountId: accountId, password: password }),
            })
                .then(function (res) { return res.json(); })
                .then(function (res) {
                if (res.hasOwnProperty('error')) {
                    reject(res.error);
                }
                else {
                    resolve();
                }
            })
                .catch(function (err) { return reject(err.message); });
        });
    };
    AccountService.prototype.changeCompany = function (accountId, companyId) {
        return new Promise(function (resolve, reject) {
            fetch('/api/account/changeCompany', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ accountId: accountId, companyId: companyId }),
            })
                .then(function (res) { return res.json(); })
                .then(function (res) {
                if (res.hasOwnProperty('error')) {
                    reject(res.error);
                }
                else {
                    resolve();
                }
            })
                .catch(function (err) { return reject(err.message); });
        });
    };
    AccountService.prototype.grantPermission = function (accountId, permissionKey) {
        return new Promise(function (resolve, reject) {
            fetch('/api/account/grantPermission', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ accountId: accountId, permissionKey: permissionKey }),
            })
                .then(function (res) { return res.json(); })
                .then(function (res) {
                if (res.hasOwnProperty('error')) {
                    reject(res.error);
                }
                else {
                    resolve();
                }
            })
                .catch(function (err) { return reject(err.message); });
        });
    };
    AccountService.prototype.revokePermission = function (accountId, permissionKey) {
        return new Promise(function (resolve, reject) {
            fetch('/api/account/revokePermission', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ accountId: accountId, permissionKey: permissionKey }),
            })
                .then(function (res) { return res.json(); })
                .then(function (res) {
                if (res.hasOwnProperty('error')) {
                    reject(res.error);
                }
                else {
                    resolve();
                }
            })
                .catch(function (err) { return reject(err.message); });
        });
    };
    return AccountService;
}());
exports.accountService = new AccountService();
//# sourceMappingURL=account.service.js.map